import { render, staticRenderFns } from "./AgentMakeMoneyAdd.vue?vue&type=template&id=25f5707e&scoped=true&"
import script from "./AgentMakeMoneyAdd.vue?vue&type=script&lang=js&"
export * from "./AgentMakeMoneyAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f5707e",
  null
  
)

export default component.exports